/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0cglyw%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1crf%7Bpadding-inline-start%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozgidpf%7Bpadding-inline-start%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12xsglyw%3Ahas(%3Afocus-visible)%2C%20._p8btglyw%3Ahover%7B--expandable-provided-elembefore-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._b31z1txw%3Ahas(%3Afocus-visible)%2C%20._1vnl1txw%3Ahover%7B--expandable-chevron-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1hl9glyw%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7B--expandable-provided-elembefore-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._v9u71txw%3Ahas(%5Baria-expanded%3Dtrue%5D%5Baria-haspopup%3Dtrue%5D)%7B--expandable-chevron-display%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._165n1bgi%7B--expandable-provided-elembefore-display%3Acontents%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mmiglyw%7B--expandable-chevron-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._165nglyw%7B--expandable-provided-elembefore-display%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mmi1txw%7B--expandable-chevron-display%3Aflex%7D");
import React, { type ReactNode, useCallback, useId, useRef, useState } from 'react';
import { cx } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import { ExpandableMenuItem as AtlasExpandableMenuItem, ExpandableMenuItemContent as AtlasExpandableMenuItemContent, ExpandableMenuItemTrigger as AtlasExpandableMenuItemTrigger } from '@atlaskit/side-nav-items/expandable-menu-item';
import { chevronDisplayCssVar, expandableMenuItemIndentation, providedElemBeforeDisplayCssVar } from '../../../common/constants';
import { List } from '../../../common/ui/list';
import { ListItem } from '../../../common/ui/list-item';
import { MenuItemBase } from '../../../common/ui/menu-item';
import type { MenuItemCommonProps } from '../../../common/ui/menu-item/types';
import { ExpandableMenuItemIcon } from './expandable-menu-item-icon';
export type ExpandableMenuItemProps = MenuItemCommonProps & {
  // Overriding the `actionsOnHover` prop to add specific JSDOCs for expandable behaviour.
  /**
   * `ReactNode` to be placed visually after the `children` and will
   * only be displayed on hover or focus, or when the expandable menu item
   * is expanded.
   *
   * It is intended for additional actions (e.g. IconButtons).
   *
   * This `ReactNode` will replace `elemAfter` on hover/focus or when expanded.
   *
   * This `ReactNode` will be rendered visually on top of the main
   * interactive element for the menu item. If this element does not
   * contain an interactive element (`button` or `a`) then `pointer-events`
   * will be set to `none` on this slot so that users can click through
   * this element onto the main interactive element of the menu item.
   */
  actionsOnHover?: ReactNode;
  actions?: ReactNode;
  /**
   * When true, suppresses padding on the inner list container.
   */
  suppressListPadding?: boolean;
  // Overriding the `elemBefore` prop to remove the `COLLAPSE_ELEM_BEFORE_TYPE` functionality
  // and to add custom jsdoc
  /**
   * The element to display before the content of the menu item.
   *
   * By default, a chevron icon will be displayed in this slot. If a custom `elemBefore`
   * is provided, the custom element will replaced by the chevron icon while the user is
   * hovering or focused on the item.
   *
   * `ExpandableMenuItemTrigger` does not respect `COLLAPSE_ELEM_BEFORE` as a chevron
   * will always be displayed.
   */
  elemBefore?: ReactNode;
  elemAfter?: ReactNode;

  /**
   * Indicates that the menu item is selected.
   */
  isSelected?: boolean;

  /**
   * If provided, the chevron icon (expand/collapse symbol) will be rendered within a separate
   * icon button element. Clicking on this icon button will not trigger the `onClick` event. It
   * will only expand or collapse the expandable.
   *
   * If a `href` is not provided, the chevron icon is rendered as part of the element.
   */
  href?: string;

  // Not using the shared `MenuItemOnClick` type here as we need to support additional arguments (analyticsAttributes)
  /**
   * Called when the user has clicked on the trigger content.
   *
   * __It is not called when the user clicks on the expand/collapse chevron icon button.__
   * This is to differentiate a click that will only "expand" the menu item _without selecting it_,
   * from a click to expand _and_ "select" or navigate to the menu item.
   *
   * If you need a callback for when the user expands or collapses the expandable, use
   * `onExpansionToggle` on the `ExpandableMenuItem` component instead.
   */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>, analyticsEvent: UIAnalyticsEvent, analyticsAttributes: {
    isExpanded: boolean;
  }) => void;
  /**
   * rovo-navigation
   * Since our implementation of this component is less composable than navigation-system specify
   * the content of the expandable menu item itself as a prop instead of children
   */
  title: string;
  /**
   * rovo-navigation
   * set the default state of an expandable menu item
   */
  defaultExpanded?: boolean;
  /**
   * Called when the chevron is clicked to expand or collapse the menu item.
   * This is separate from `onClick`, which is called when the trigger content is clicked.
   */
  onExpansionToggle?: () => void;
  /**
   * Whether the ADS navigation (left-nav) is enabled rather than the in-component navigation
   */
  isADSNavigationEnabled: boolean;
};
export const nestedOpenPopupCSSSelector = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const wrapperStyles = {
  root: "_1mmi1txw _165nglyw",
  showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const listContentStyles = {
  noPadding: "_bozgidpf",
  content: "_bozg1crf",
  collapsedContent: "_1e0cglyw"
};

/** support 1 level of nesting. For now, all expandable side nav items are at level 0 */
const LEVEL = 0;

/**
 * An expandable button menu item which holds expandable logic and styles
 *
 * rovo-navigation
 * This component combines ExpandableMenuItem, ExpandableMenuItemTrigger, and ExpandableMenuItemContent
 * from design-system/navigation system. This is to reduce complexity and for our side panel use-case.
 */
export const ExpandableMenuItem = ({
  actions,
  isSelected,
  href,
  elemBefore: providedElemBefore,
  elemAfter,
  actionsOnHover,
  onClick,
  onExpansionToggle: onExpansionToggleProp,
  children,
  testId,
  interactionName,
  title,
  defaultExpanded = false,
  isADSNavigationEnabled,
  suppressListPadding
}: ExpandableMenuItemProps): JSX.Element => {
  const id = useId();
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const itemRef = useRef<HTMLDivElement>(null);
  const onExpansionToggle = useCallback(() => {
    setIsExpanded(prevExpanded => !prevExpanded);
    onExpansionToggleProp?.();
  }, [setIsExpanded, onExpansionToggleProp]);
  const handleMenuContentClick = useCallback((event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>, analyticsEvent: UIAnalyticsEvent) => {
    onClick?.(event, analyticsEvent, {
      isExpanded: !isExpanded
    });
    setIsExpanded(prevExpanded => !prevExpanded);
  }, [onClick, setIsExpanded, isExpanded]);

  // Wrapped in an IconButton if the expandable menu item trigger is selectable
  const elemBefore = <IconButton icon={iconProps => <ExpandableMenuItemIcon iconProps={iconProps} isExpanded={isExpanded} isSelected={isSelected} providedElemBefore={providedElemBefore} />} aria-expanded={isExpanded}
  // We are labelling the icon button using the containing menu item's content, to provide context to
  // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
  // `aria-expanded` attribute to indicate the expanded state of the menu item.
  // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
  aria-labelledby={id}
  // IconButton requires a label prop, however it will not be used by screen readers as we are setting
  // `aria-labelledby`, which will be used instead.
  label="" appearance="subtle" spacing="compact" onClick={onExpansionToggle} interactionName={interactionName} testId={testId ? `${testId}--elem-before-button` : undefined} />;
  return isADSNavigationEnabled ? <AtlasExpandableMenuItem isExpanded={isExpanded} isDefaultExpanded={defaultExpanded} onExpansionToggle={onExpansionToggle}>
			<AtlasExpandableMenuItemTrigger actions={actions} actionsOnHover={actionsOnHover} elemAfter={elemAfter} elemBefore={providedElemBefore} href={href} isSelected={isSelected} testId={testId} interactionName={interactionName} onClick={handleMenuContentClick}>
				{title}
			</AtlasExpandableMenuItemTrigger>
			<AtlasExpandableMenuItemContent>{children}</AtlasExpandableMenuItemContent>
		</AtlasExpandableMenuItem> : <ListItem>
			<div ref={itemRef} className={ax([wrapperStyles.root, providedElemBefore && wrapperStyles.showProvidedElemBefore])}>
				<MenuItemBase id={id} actions={actions} actionsOnHover={actionsOnHover} elemBefore={elemBefore} ariaExpanded={isExpanded} elemAfter={elemAfter} href={href} isSelected={isSelected} onClick={handleMenuContentClick} testId={testId} interactionName={interactionName} level={LEVEL}>
					{title}
				</MenuItemBase>
			</div>
			<List xcss={cx(listContentStyles.content, !isExpanded && listContentStyles.collapsedContent, suppressListPadding && listContentStyles.noPadding)}>
				{children}
			</List>
		</ListItem>;
};